<template>
  <MoleculeFrameCard spacing="sm" :content-theme="contentTheme">
    <div class="flex">
      <AtomPicto name="bill" size="md" />
      <div>
        <AtomText
          :text="t('subscription.billingMode.annualBudget.title')"
          font-size="text-sm"
          font-style="font-medium"
        />
        <AtomText
          font-style="font-bold"
          font-size="text-3xl"
          class="mt-1"
          data-cy="annual-budget-summary-price"
        >
          {{ formatEuroPrice(getBudgetPrices?.totalAnnual ?? null) }}
          <AtomText
            is-tag="span"
            :text="t('subscription.billingMode.annualBudget.unit')"
            font-style="font-medium"
            font-size="text-sm"
            class="mt-2"
          />
        </AtomText>
        <div
          v-if="isEligibleForWelcomeOffer"
          class="mt-1"
          data-cy="annual-budget-summary-promotional-description"
        >
          <AtomText
            :text="t('subscription.billingMode.annualBudget.promotionalDescription.firstYear')"
            font-size="text-sm"
            color-variant="description"
          />
        </div>
        <AtomText
          v-else
          :text="t('subscription.billingMode.annualBudget.description')"
          font-size="text-sm"
          color-variant="description"
          class="mt-1"
        />
      </div>
    </div>

    <MoleculeButton
      v-if="hasDetailButton"
      :label="t('subscription.billingMode.annualBudget.detailLink')"
      variant="tertiary"
      expanded
      class="mt-3"
      data-cy="billing-mode-annual-budget-detail-button"
      @clicked="emit('detail')"
    />
  </MoleculeFrameCard>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import { useSubscriptionStore } from '@/stores';

import { formatEuroPrice } from '@/utils/format.util';

withDefaults(defineProps<{ contentTheme?: 'dark' | 'info'; hasDetailButton?: boolean }>(), {
  contentTheme: 'dark',
  hasDetailButton: false,
});

const emit = defineEmits<{ detail: [] }>();

const { t } = useI18n();

const { getBudgetPrices, isEligibleForWelcomeOffer } = storeToRefs(useSubscriptionStore());
</script>
